export class HtmlBuilder {
	constructor(ids, classes, content) {
		this.ids = ids
		this.classes = classes
		this.content = content
	}

	build() {
		return `<wfs-counter
      id="${this.ids.containerId}"
      class="${this.classes.containerClasses}"
      counter="${this.content.counter}"
      interval="${this.content.interval}"
    >
      <template v-slot:counter="{counted}">
        ${this.getCounterBuilder()}
        ${this.getTitle()}
      </template>
    </wfs-counter>`
	}

	getCounterBuilder() {
    return `<div
      id="${this.ids.counterId}"
      class="${this.classes.counterClasses}"
    >${this.getPrefix()}${this.getCounter()}${this.getSuffix()}</div>`;
  }

  getCounter() {
    return `<span v-text="counted"></span>`
  }

  getPrefix() {
    if (this.content.hasPrefix) {
      return `<span>${this.content.prefix}</span>`
    }
    return ``
  }

  getSuffix() {
    if (this.content.hasSuffix) {
      return `<span>${this.content.suffix}</span>`
    }
    return ``
  }

  getTitle() {
    if (this.content.hasTitle) {
      return `<div
        id="${this.ids.titleId}"
        class="${this.classes.titleClasses}"
      >${this.content.text}</div>`
    }
    return ``
  }
}
